module.exports = __webpack_public_path__ + "static/scale-model-of-gerlinger-lounge-in-eugene-oregon-f4f7aaea1bcd64b05938c4783fc97085.png";